<div class="flex flex-column">
    <div class="fieldset__header h-3rem flex justify-content-start align-items-center gap-2">
        <i class="{{ icon }} + ' font-semibold'"></i>
        <p class="text-xl text-700 font-light">{{ header | translate }}</p>
    </div>
    <div class="fieldset__border fieldset__content h-auto">
        <ng-content></ng-content>
    </div>
</div>
